import { BehaviorSubject } from "@/lib/behavior-subject";
import { Subject } from "@/lib/subject";
import type { NotificationSubscriber } from "./lib";
import type { IPushNotification, IWorkerInfo } from "./pwa.types";

export const PWA_EVENTS = {
  NotificationSubscriber: new BehaviorSubject<NotificationSubscriber | null>(null),
  Notification: new Subject<IPushNotification>(),
  NotificationAccess: new BehaviorSubject<NotificationPermission>("denied"),
  NotificationSubscribed: new BehaviorSubject<boolean>(false),
  WorkerInfo: new Subject<IWorkerInfo>(),
  WorkerRegistered: new BehaviorSubject<boolean>(false),
  WorkerInstalled: new Subject<void>(),
  WorkerActivated: new Subject<void>(),
  ActivateWorker: new Subject<void>(),
};
